var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPictureinPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M.5 14.499a1 1 0 011-1h8a1 1 0 011 1v8a1 1 0 01-1 1h-8a1 1 0 01-1-1v-8z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 9V1.5a1 1 0 011-1h8M14.5.5h8a1 1 0 011 1v8M23.5 14.5v8a1 1 0 01-1 1H15",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC41IDE0LjQ5OUMwLjUgMTMuOTQ2NyAwLjk0NzcxNSAxMy40OTkgMS41IDEzLjQ5OUg5LjVDMTAuMDUyMyAxMy40OTkgMTAuNSAxMy45NDY3IDEwLjUgMTQuNDk5VjIyLjQ5OUMxMC41IDIzLjA1MTMgMTAuMDUyMyAyMy40OTkgOS41IDIzLjQ5OUgxLjVDMC45NDc3MTYgMjMuNDk5IDAuNSAyMy4wNTEzIDAuNSAyMi40OTlWMTQuNDk5WiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0wLjUgOVYxLjVDMC41IDAuOTQ3NzE1IDAuOTQ3NzE1IDAuNSAxLjUgMC41SDkuNSIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC41IDAuNUgyMi41QzIzLjA1MjMgMC41IDIzLjUgMC45NDc3MTUgMjMuNSAxLjVWOS41IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIzLjUgMTQuNVYyMi41QzIzLjUgMjMuMDUyMyAyMy4wNTIzIDIzLjUgMjIuNSAyMy41SDE1IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgPictureinPicture as ReactComponent };